import React, { useEffect, useReducer, useState } from 'react';

import { useAuth } from '../../Context';
import { Content } from 'antd/es/layout/layout';
import { Avatar, Breadcrumb, Button, Card, Col, Empty, Form, Input, message, Modal, Popover, Row,  Select,  Space, Spin, Switch, Table,  Tooltip,  Typography } from 'antd';
import { EditOutlined, PlusOutlined, DeleteOutlined, InfoOutlined,  NodeIndexOutlined, HomeOutlined } from '@ant-design/icons';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import axios from 'axios';
import chainselectorReducer from './reducer';
import { CHAINSELECTORCONFIG_SUCCESS, CHAINSELECTORCONFIG_ERROR, CHAINSELECTORCONFIG_CREATE, CHAINSELECTORCONFIG_CREATE_SUCCESS, CHAINSELECTORCONFIG_CREATE_ERROR, CHAINSELECTORCONFIG_DELETE, CHAINSELECTORCONFIG_DELETE_SUCCESS, CHAINSELECTORCONFIG_DELETE_ERROR, EDIT_CHAINSELECTORCONFIG, EDIT_CHAINSELECTORCONFIG_SUCCESS, EDIT_CHAINSELECTORCONFIG_ERROR, CHAINSELECTORCONFIG_LIST, CHAINSELECTORCONFIG_UPDATE_DATA, MULTIPLEMODEL_LIST_SUCCESS, MULTIPLEMODEL_LIST_ERROR } from './constants';
import { useFormik } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';

const { Title } = Typography;

export default function ChainSelectorConfiguration() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const initalState = {chainselectorconfigdata : {}, loading: false, error: false, chainselectorconfigUpdateData : [], multimod : []};
	const [data, dispatch] = useReducer(chainselectorReducer, initalState);
	const [isEditModalOpen, setIsEditModalOpen] = useState(false);
	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	// const {wellalgorithmdata} = useAuth();
	useAuth();
	// const [updateId, setUpdateId]= useState();
	const [showDeleteModal, setShowDeleteModal] = useState();
	const [deleteId, setDeleteId] = useState();
	// const [overrideBtn, setOverrideBtn] = useState(false);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const [stateconfigs, setStateConfigs] = useState([{name : '', value : '' , default : '' , override : false}]);
	// const [form] = Form.useForm();	
	const navigate = useNavigate();
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;	
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const { pidsData,  getPids, channelData, getChannels } = useAuth();
	const [pidsFilter, setpidsFilter] = useState();
	const [pidsId, setPidsId] = useState(null);
	const [channelsdata, setchannels] = useState();
	const [channelId, setChannelId] = useState();
	const [ChainId, setChainId] = useState();
	const [existingConfig, setexistingConfigs] = useState([]);
	const location = useLocation();
	const {chainselectorId} = location.state;

	useEffect(() => {
		if(featuresModule.chainselectorEnabled == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4031);
		loadchainselectorconfig();
		getPids(authtoken);
		if(pidsFilter!=null){
			getChannels(authtoken, pidsFilter);

		}
	}, [pidsFilter, channelsdata]);

	useEffect(()=>{
		if(pidsId != null){
			getChannels(authtoken, pidsId);

		}
	},[pidsId]);

	

	const loadchainselectorconfig = ()=>{    
		let params = '';
		if(pidsFilter){
			params += `&pidsinfoId=${pidsFilter}`;
		}

		if(channelsdata){
			params += `&channelinfoId=${channelsdata}`;
		}

		if(chainselectorId){
			params += `&chainselectorId=${chainselectorId}`;
		}

		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/chainselectorconfig/?pipelineId=${pipelineId}&$sort[id]=-1${params}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				
			},
		};
		dispatch({type : CHAINSELECTORCONFIG_LIST});
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){	
					dispatch({ type : CHAINSELECTORCONFIG_SUCCESS, payload: response.data });
				} else {
					dispatch({ type : CHAINSELECTORCONFIG_ERROR});			
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : CHAINSELECTORCONFIG_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });											
				}
			});
	};
	const loadMultiplemodels = (channelinfoId) => {
		
		// let params ='';
	
		// if(id){
		// 	params = `&channelinfoId=${id}`;
		// }
	
	
	
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/multiplemodels/?pipelineId=${parseInt(pipelineId)}&$sort[id]=-1&channelinfoId=${channelinfoId}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
	
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type:MULTIPLEMODEL_LIST_SUCCESS, payload: response.data});
				}
			})
			.catch((error) => {
				dispatch({type:MULTIPLEMODEL_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
	};
	const columns = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
			
		},
		{
			title: langdata && langdata.PIDS ? langdata.PIDS : 'PIDS',
			dataIndex: 'pidsinfo',
			key: 'pidsinfo',
			
		},
		{
			title: langdata && langdata.ChannelName ? langdata.ChannelName : 'Channel Name',
			dataIndex: 'channelname',
			key: 'channelname',
			
		},
		{
			title: langdata && langdata.ModelName ? langdata.ModelName : 'Model Name',
			dataIndex: 'multiplemodelsname',
			key: 'multiplemodelsname',
			
		},

	];
	
	permission==='superadmin' || permission === 'admin' ? 
		columns.push({
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				<Space size="middle">
					<a title={langdata && langdata.Edit ? langdata.Edit : 'Edit'} onClick={() => {showModal(record);getChannels(authtoken,record.pidsinfoId);loadMultiplemodels(record.channelinfoId);}} ><EditOutlined/></a>
					<a title={langdata && langdata.Delete ? langdata.Delete : 'Delete'} onClick={() => {openUserModal(record);}} ><DeleteOutlined /></a>
				</Space>
			)
		}) : null;

	
	const showModal = (value) => {
		setIsEditModalOpen(true);
		dispatch({ type : CHAINSELECTORCONFIG_UPDATE_DATA , payload : value});
		setexistingConfigs(Object.entries(value?.configs));
	};

	const handleOk = () => {
		setIsEditModalOpen(false);
		setIsAddModalOpen(false);
		setShowDeleteModal(false);
		createFormik.resetForm();
		editFilterConfig.resetForm();
		setchannels(null);
		setChannelId(null);
		setChainId(null);
		
	};
	const handleCancel = () => {
	
		setIsEditModalOpen(false);
		setIsAddModalOpen(false);
		setShowDeleteModal(false);
		setStateConfigs([{name : '', value : '' , default : '' , override : false}]);
		createFormik.resetForm();
		editFilterConfig.resetForm();
		setchannels(null);
		setPidsId(null);
		setChannelId(null);
		setChainId(null);
		

	};	

	

	const createFormik = useFormik({
		// enableReinitialize: true,
		initialValues : {
			name : null,
			channelinfoId : null,
			pidsinfoId : null,
			multiplemodelsId : null,
			
		},
		onSubmit: (values) => {
			if( values.name == null){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}
			if( values.pidsinfoId == null){
				Modal.warning({title : langdata && langdata.Pleaseselectthepids ? langdata.Pleaseselectthepids : 'Please select the pids'});
				return false;
			}
			if( values.channelinfoId == null){
				Modal.warning({title : langdata && langdata.Pleaseselectthechannel ? langdata.Pleaseselectthechannel : 'Please select the channel'});
				return false;
			}
			if( values.multiplemodelsId == null){
				Modal.warning({title : langdata && langdata.PleaseSelectModel ? langdata.PleaseSelectModel : 'Please Select the Model'});
				return false;
			}
			if( chainselectorId == null || chainselectorId == undefined){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}
			const payload = {
				name: values.name,
				configs: {
					...buildConfigsFromState(stateconfigs),
				},
				pipelineId : parseInt(pipelineId),
				channelinfoId : values.channelinfoId,
				pidsinfoId : values.pidsinfoId,
				multiplemodelsId : values.multiplemodelsId,
				chainselectorId : chainselectorId
			};
			
		
			
			dispatch({ type : CHAINSELECTORCONFIG_CREATE });
			// let data = JSON.stringify({
			// 	'name' : name,
			// 	'pipelineId':parseInt(pipelineId)
				
			// });

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/chainselectorconfig`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`				},
				data : {
					name : payload.name,
					configs : payload.configs,
					pipelineId : payload.pipelineId,
					channelinfoId : payload.channelinfoId,
					pidsinfoId : payload.pidsinfoId,
					multiplemodelsId : payload.multiplemodelsId,
					chainselectorId : payload.chainselectorId

				} 
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201){
						loadchainselectorconfig();		
						Modal.success({ title: langdata && langdata.chainselectorconfigsavedsuccessfully ? langdata.chainselectorconfigsavedsuccessfully : 'Chain selector config saved successfully' });					
						dispatch({ type : CHAINSELECTORCONFIG_CREATE_SUCCESS });

					} else {
						dispatch({ type : CHAINSELECTORCONFIG_CREATE_ERROR });
						Modal.warning({ title: langdata && langdata.Unabletosavechainselector ? langdata.Unabletosavechainselector : 'Unable to save chain selector.' });					
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : CHAINSELECTORCONFIG_CREATE_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Unabletosavechainselector ? langdata.Unabletosavechainselector : 'Unable to save chain selector' });					
					}
				});
			createFormik.resetForm();
			setIsAddModalOpen(false);
			setStateConfigs([{name : '' , value : '', default : '', override : false}]);

		}
	});	
		
	const openUserModal = (value) => {
		setShowDeleteModal(true);
		setDeleteId(value.id);

	};

	const handleDelete = () => {
		dispatch({ type : CHAINSELECTORCONFIG_DELETE });
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/chainselectorconfig/${deleteId}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				},
			data : data
		};

		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){
					loadchainselectorconfig();					
					Modal.success({ title: langdata && langdata.Chainselectorconfigsuccessfullydeleted ? langdata.Chainselectorconfigsuccessfullydeleted : 'Chain selector config successfully deleted' });					
					dispatch({ type : CHAINSELECTORCONFIG_DELETE_SUCCESS });
				} else {
					Modal.warning({ title: langdata && langdata.Unabletodeletechainselectorconfig? langdata.Unabletodeletechainselectorconfig : 'Unable to delete chain selector config'});					
					dispatch ({ type : CHAINSELECTORCONFIG_DELETE_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch ({ type : CHAINSELECTORCONFIG_DELETE_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					Modal.warning({ title: langdata && langdata.Unabletodeletechainselectorconfig? langdata.Unabletodeletechainselectorconfig : 'Unable to delete chain selector config' });
				}
			});
		setShowDeleteModal(false);
	};

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p style={{textAlign:'justify'}}> {langdata && langdata.ChainselectorconfigInfoContent ? langdata.ChainselectorconfigInfoContent : 'Chain Selector Config is the module that manages chain-specific configurations for each selector with respect to PIDS and channels.'} </p>
		</Card>
	);

	const buildConfigsFromValues = (values) => {
		const configsMap = {};

		Object.keys(values).forEach((k) => {
			if (k === 'name') return;

			if (k.endsWith('value')) {
				const baseKey = k.replace('value', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].value = !isNaN(values[k]) ? parseFloat(values[k]) : values[k];
			}

			if (k.endsWith('default')) {
				const baseKey = k.replace('default', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].default = !isNaN(values[k]) ? parseFloat(values[k]) : values[k];
			}

			if (k.endsWith('override')) {
				const baseKey = k.replace('override', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].override = values[k];
			}
			if (k.endsWith('infoContent')) {
				const baseKey = k.replace('infoContent', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].infoContent = values[k];
			}
			if (k.endsWith('sort')) {
				const baseKey = k.replace('sort', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].sort = values[k];
			}
		});

		// Return object (not array)
		return configsMap;
	};

	const buildConfigsFromState = (stateconfigs) => {
		return stateconfigs.reduce((acc, item) => {
			if (item.name && item.value !== '') {
				acc[item.name] = {
					value: !isNaN(item.value) ? parseFloat(item.value) : item.value,
					default: !isNaN(item.default) ? parseFloat(item.default) : item.default,
					override: Boolean(item.override),
					infoContent : item.infoContent,
					sort : item.sort
				};
			}
			return acc;
		}, {});
	};


	const editFilterConfig = useFormik({
		enableReinitialize: true,
		// initialValues : {
		// 	name : data.wellalgorithmUpdateData.name,
		// },
		initialValues: {
			name: data?.chainselectorconfigUpdateData?.name,
			channelinfoId : data?.chainselectorconfigUpdateData?.channelinfoId,
			pidsinfoId: data?.chainselectorconfigUpdateData?.pidsinfoId,
			multiplemodelsId: data?.chainselectorconfigUpdateData?.multiplemodelsId,

			...(existingConfig
				? existingConfig.reduce(
					(acc, [key, inner]) => {
						acc[`${key}value`] =inner.value;
						acc[`${key}default`] = inner.default;
						acc[`${key}override`] = inner.override;
						acc[`${key}infoContent`] = inner.infoContent;
						acc[`${key}sort`] = inner.sort;
						return acc;
					},
					{}
				)
				: {}),

		},
		onSubmit: (values) => {

			const payload = {
				name: values.name,
				pidsinfoId : values.pidsinfoId,
				channelinfoId : values.channelinfoId,
				multiplemodelsId : values.multiplemodelsId,	
				configs: {
					...buildConfigsFromValues(values),
					...buildConfigsFromState(stateconfigs),
				},
				
			};

			
		
			dispatch({type:EDIT_CHAINSELECTORCONFIG});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/chainselectorconfig/${data?.chainselectorconfigUpdateData?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data:{
					name : payload.name,
					configs : payload.configs,
					pidsinfoId : payload.pidsinfoId,
					channelinfoId : payload.channelinfoId,
					multiplemodelsId : payload.multiplemodelsId,
					pipelineId : parseInt(pipelineId)
				}
			};
		
			axios
				.request(config)	
				.then((response) => {
							
		
					if (response.status === 200 || response.status === 201) {
						dispatch( { type: EDIT_CHAINSELECTORCONFIG_SUCCESS, payload: response.data.data });
						Modal.success({ title: `${langdata && langdata.EditChainselectorSuccessfull ? langdata.EditChainselectorSuccessfull :'Edit Chain selector Successfull'}` });
						setIsEditModalOpen(false);
						loadchainselectorconfig();
						setStateConfigs([{name : '', value : '' , default : '' , override : false}]);
					}
				})
				.catch((error) => {
					console.log(error);
							
					dispatch({ type: EDIT_CHAINSELECTORCONFIG_ERROR
					});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
		
		}
	});



	const handleOverride = (value, key)=>{
		editFilterConfig.setFieldValue(`${key}override`, value);
	};

	const handleFilterConfig = () => {
		// setSuppressionValues([...suppressionValues, { Start: '', End: '' }]);
		setStateConfigs([...stateconfigs, {name : '' , value : '', default : '', override : false}]);
	};

	const handleChangeConfigs = (index, key, e)=>{

		const newConfig = [...stateconfigs];
		if(key == 'override'){
			newConfig[index][key] = e;
		}else{
			newConfig[index][key] = e.target.value;
		}
		setStateConfigs(newConfig);
	};


	const handleDeleteConfig = (index) => {
		setStateConfigs(stateconfigs.filter((_, i) => i !== index));
	};

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());
	
	let pidsfilter=[{value:null, label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}` }];
	let pidsModalFilter = [];
	
	pidsData && pidsData.map((pid)=>{
		pidsfilter.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
		pidsModalFilter.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
	});

	let multiplemodelfilter = [];

	data?.multimod && data?.multimod.map((pid)=>{
		multiplemodelfilter.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
	});

	const handlepidsfilter = (value) =>{
		setpidsFilter(value);
		setchannels(null);
		
	};

	const handleSelect = (e, option)=> {
		setPidsId(e);
		editFilterConfig.setFieldValue('multiplemodelsId', null);
		editFilterConfig.setFieldValue('channelinfoId', null);
		setchannels(null);
		setChannelId(null);
		setChainId(null);
		setChainId(null);

		if(option == 'add'){
			createFormik.setFieldValue('pidsinfoId', e);
		}
		if(option == 'edit'){
			editFilterConfig.setFieldValue('pidsinfoId', e);

		}
	};
	const handleSelectChannel = (e, options)=>{
		// setchannels(e);
		setChannelId(e);
		setChainId(null);
		createFormik.setFieldValue('multiplemodelsId', null);
		if(options == 'add'){
			createFormik.setFieldValue('channelinfoId', e);
		}
		if(options == 'edit'){
			editFilterConfig.setFieldValue('channelinfoId', e);
			// editFilterConfig.setFieldValue('multiplemodelsId', null);
			
		}

		loadMultiplemodels(e);

	};
	let channels = [];
	channelData && channelData.map((item) => {
		channels.push({
			value : item.id,
			label : item.name,
		});
	});

	const handleSelectModel = (e, options)=>{
		setChainId(e);
		if(options == 'add'){
			createFormik.setFieldValue('multiplemodelsId', e);
		}
		if(options == 'edit'){
			editFilterConfig.setFieldValue('multiplemodelsId', e);
			
		}

	};
	const handleDeleteexistingConfig = (index) => {
		setexistingConfigs(existingConfig.filter((_, i) => i !== index));
	};
	
	return (
		<Content>
			<Breadcrumb
				items={[
					{
						href: '/dashboard',
						title: <HomeOutlined />,
					},
					{
						title:  
							<a onClick={() => navigate(-1)}>
								{langdata&&langdata.ChainSelector?langdata.ChainSelector: 'Chain Selector'}
							</a>
					},
					{
						title: langdata && langdata.ChainSelectorConfig ? langdata.ChainSelectorConfig : 'Chain Selector Configuration'
					}
						
				]}
				style={{ margin: '10px' }}
			/>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center',
			}}
			>
				<Col span={8}>
					<Row>
						<Space>
							<NodeIndexOutlined  style={{fontSize:'30px'}} />
						</Space>
						<Space>&nbsp;&nbsp;</Space>
						<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.ChainSelectorConfig ? langdata.ChainSelectorConfig : 'Chain Selector Configuration'}</Title>
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Space>
							<Tooltip placement="bottom" title={langdata && langdata.Filterbypids ? langdata.Filterbypids :'Filter by pids'}>
																				
								<Space>
									<Select Item
										style={{ minWidth: '200px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
										optionFilterProp="children"
										defaultValue={null}
										options={pidsfilter}
										onSelect={(e)=> handlepidsfilter(e)}										
									/>  
								</Space>
							</Tooltip>  
						</Space>
						<Space>
							<Tooltip placement="bottom" title={langdata && langdata.Filterbychannel ? langdata.Filterbychannel :'Filter by channel'}>
																											
								<Space>
									<Select Item
										style={{ minWidth: '200px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={
											langdata && langdata.SelectChannel
												? langdata.SelectChannel
												: 'Select Channel'
										}
										optionFilterProp="children"
										value={channelsdata}
										options={channels}
										disabled={pidsFilter==null}
										onSelect={(e) => setchannels(e)}
																									
																											
									/>  
								</Space>
							</Tooltip>  
						</Space>
						<Col>
							{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>User Type:</Text> */}
							{ permission==='superadmin' || permission === 'admin' ? 
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={() => {setIsAddModalOpen(true);}}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
								: null }
							<Space>&nbsp;&nbsp;&nbsp;</Space>
							
							<Popover title={langdata && langdata.ChainSelectorConfig ? langdata.ChainSelectorConfig : 'Chain Selector Configuration'}  content={infoContent} trigger="click">
								<Avatar size="small"><InfoOutlined /></Avatar>
							</Popover>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row span={24} style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
				<Col span={24}>
					{ data?.chainselectorconfigdata && data.chainselectorconfigdata.length > 0 ? (
						<Table
							scroll={{
								x: 900,
							}}
							columns = { columns } 
							dataSource = { data?.chainselectorconfigdata } 
						/>
					)
						:
						(
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						)}
				</Col>
			</Row>
			<Modal
				title={langdata && langdata.EditChainselectorConfiguration ? langdata.EditChainselectorConfiguration : 'Edit Chain selector Configuration'}
				centered
				open={isEditModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={editFilterConfig.handleSubmit}>{langdata && langdata.UPDATE ? langdata.UPDATE : 'UPDATE'}</Button>
					</Space>
				]}
				width={900}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: false, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} required>
								<Input 
									name="name" 
									onChange={editFilterConfig.handleChange} 
									disabled
									value={editFilterConfig.values.name}
								/>
							</Form.Item>
						</Col>
						
					</Row>

					<Row gutter={24}>
						<Col span={12}>
							<Form.Item label={langdata && langdata.PIDS ? langdata.PIDS : 'PIDS'} rules={[{ required: true, message: langdata && langdata.Pleaseselectthepids ? langdata.Pleaseselectthepids : 'Please fill the pids' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelectPids ? langdata.SelectPids : 'Select Pids'}
									optionFilterProp="children"
									value={editFilterConfig.values.pidsinfoId}
									options={pidsModalFilter}
									// onSelect={(e)=>setPidsId(e)}
									onSelect={(e)=>handleSelect(e,'edit')}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item label={langdata && langdata.ChannelName ? langdata.ChannelName : 'Channel Name'} rules={[{ required: true, message: langdata && langdata.Pleaseselectthechannel ? langdata.Pleaseselectthechannel : 'Please select the channel' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={
										langdata && langdata.SelectChannel
											? langdata.SelectChannel
											: 'Select Channel'
									}
									optionFilterProp="children"
									value = {editFilterConfig.values.channelinfoId}
									// defaultValue={editFilterConfig.values.channelinfoId}
									options={channels}
									disabled={pidsId==null}
									onSelect={(e) => handleSelectChannel(e,'edit')}
																											
																													
								/>  
							</Form.Item>
						</Col>
					</Row>
					
					<Row gutter={24}>

						<Col span={12}>
							<Form.Item label={langdata && langdata.Chain ? langdata.Chain : 'Chain'} rules={[{ required: true, message: langdata && langdata.PleaseSelectChain ? langdata.PleaseSelectChain : 'Please Select the  Chain' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={
										langdata && langdata.PleaseSelectChain ? langdata.PleaseSelectChain : 'Please Select the  Chain'
									}
									optionFilterProp="children"
									// value={channelId}
									options={multiplemodelfilter}
									disabled={channelId==null}
									value={editFilterConfig.values.multiplemodelsId}
									onSelect={(e) => handleSelectModel(e,'edit')}
																											
																													
								/>  
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={12} style={{marginBottom : '15px'}}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Configuration ? langdata.Configuration:'Configuration'}</b></Typography>
						</Col>
					</Row>

					{
						existingConfig.length <= 0 ? (
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						) : null
					}

					{
						existingConfig.sort(([, a], [, b]) => a.sort - b.sort).map(([key], index) => (
							
								
							<Row gutter={24} align='middle' key={key}>
								<Col span={7} >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : 'none',marginTop : '10px'}}>
												{index === 0 ? langdata?.Name || 'Name' : ''}
											</Typography>
										}
									>
										<Input
												
											disabled
											value={key}
											suffix = {
												<Popover 
													title={langdata && langdata.Info ? langdata.Info : 'Info'}
													content={editFilterConfig.values[`${key}infoContent`]}
													trigger="click"
												>
													<Avatar size={18} style={{ cursor: 'pointer' }}>
														<InfoOutlined />
													</Avatar>
												</Popover>
											}
																						
										/>
									</Form.Item>
								</Col>

								<Col span={6} >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : '0px', marginTop : '10px'}}>
												{index === 0 ? langdata?.Value || 'Value' : ''}
											</Typography>
										}
									>
										<Input
											name={`${key}value`}
											onChange={editFilterConfig.handleChange}
											disabled={editFilterConfig.values[`${key}override`] ? false : true}
												
											value={editFilterConfig.values[`${key}value`]}
										/>
									</Form.Item>
								</Col>
								<Col span={6} >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : '0px', marginTop : '10px'}}>
												{index === 0
													? langdata?.DefaultValue || 'DefaultValue' : ''}
											</Typography>
										}
									>
										<Input
											name={`${key}default`}
											disabled
											onChange={editFilterConfig.handleChange}
												
											value={editFilterConfig.values[`${key}default`]}
										/>
									</Form.Item>
								</Col>
								<Col span={3} style={{justifyContent: 'center', display : 'flex'}}  >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : '0px', marginTop : '10px', minWidth : '50px'}} >
												{index === 0 ? langdata?.Override || 'Override' : ''}
											</Typography>
										}
									>
										<Switch
												
											size="small"
											checked={editFilterConfig.values[`${key}override`]}
											onChange={(value) => handleOverride(value, key)}
										/>
									</Form.Item>
								</Col>
								<Col span={2} style={{ marginTop : '19px' , marginLeft : '', textAlign: 'center' }}>
									<Button
										danger
										icon={<DeleteOutlined />}
										onClick={() => handleDeleteexistingConfig(index)}
										disabled={existingConfig.length === 0}
									/>
								</Col> 
								
							</Row>

							
						)
						)
					}

					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.NewConfiguration ? langdata.NewConfiguration:'New Configuration'}</b></Typography>
						</Col>
						<Col span={12} justifyContent="end" style={{display:'flex', justifyContent:'flex-end'}}>
							<Button
								style={{margin:'5px'}} 
								type="primary" 
								icon={<PlusOutlined />}
								onClick={handleFilterConfig}
							/>
						</Col>
					</Row>
					{
						stateconfigs.map((item, stateindex)=>{
							return (
								<><Row gutter={24} key={stateindex}>
									<Col span={7}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : 'none', marginTop: '10px' }}>
												{stateindex === 0 ? langdata?.Name || 'Name' : ''}
											</Typography>}
										>
											<Input
												placeholder={langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name'}
												onChange={e => handleChangeConfigs(stateindex, 'name', e)}
												value={item.name} 
											/>
										</Form.Item>
									</Col>
									<Col span={6}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0 ? langdata?.Value || 'Value' : ''}
											</Typography>}
										>
											<Input
												onChange={e => handleChangeConfigs(stateindex, 'value', e)}
												value={item.value}
												placeholder={langdata && langdata.Value ? langdata.Value : 'Value'} />
										</Form.Item>
									</Col>
									<Col span={6}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0
													? langdata?.DefaultValue || 'DefaultValue' : ''}
											</Typography>}
										>
											<Input
												onChange={e => handleChangeConfigs(stateindex, 'default', e)}
												value={item.default}
												placeholder={langdata && langdata.DefaultValue ? langdata.DefaultValue : 'Default Value'} />
										</Form.Item>
									</Col>
									<Col span={3} style={{ justifyContent: 'center', display: 'flex' }}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px', minWidth: '50px' }}>
												{stateindex === 0 ? langdata?.Override || 'Override' : ''}
											</Typography>}
										>
											<Switch

												size="small"
												checked={item.override}
												onChange={(e) => {
													handleChangeConfigs(stateindex, 'override', e);
												} } />
										</Form.Item>
									</Col>

									<Col span={2} style={{ marginTop: '35px', marginLeft: '', textAlign: 'center' }}>
										<Button
											danger
											icon={<DeleteOutlined />}
											onClick={() => handleDeleteConfig(stateindex)}
											disabled={stateconfigs.length === 0} />
									</Col>
								</Row>
								<Row gutter={24}>
									<Col span={12}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0
													? langdata?.infoContent || 'Info Content' : ''}
											</Typography>}
										>
											<Input
												onChange={e => handleChangeConfigs(stateindex, 'infoContent', e)}
												value={item.infoContent}
												placeholder={langdata && langdata.infoContent ? langdata.infoContent : 'Info Content'} />
										</Form.Item>	
									</Col>
									<Col span={12}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0
													? langdata?.OrderId || 'Order Id' : ''}
											</Typography>}
										>
											<Input
												type='number'
												onChange={e => handleChangeConfigs(stateindex, 'sort', e)}
												value={item.sort}
												placeholder={langdata && langdata.OrderId ? langdata.OrderId : 'Order Id'} />
										</Form.Item>	
									</Col>
								</Row></>	
							);
						})
					}


					
					
					
				</Form>
			</Modal>


			<Modal
				title={langdata && langdata.AddChainselectorConfig ? langdata.AddChainselectorConfig : 'Add Chain selector Configuration'}
				centered
				open={isAddModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				destroyOnClose= {true}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={createFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE'}</Button>
					</Space>
				]}
				width={900}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} required>
								<Input 
									name="name" 
									placeholder={langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name'}
									onChange={createFormik.handleChange} 
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={12}>
							<Form.Item label={langdata && langdata.PIDS ? langdata.PIDS : 'PIDS'} rules={[{ required: true, message: langdata && langdata.Pleaseselectthepids ? langdata.Pleaseselectthepids : 'Please fill the pids' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelectPids ? langdata.SelectPids : 'Select Pids'}
									optionFilterProp="children"
									defaultValue={null}
									options={pidsModalFilter}
									// onSelect={(e)=>setPidsId(e)}
									onSelect={(e)=>handleSelect(e,'add')}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item label={langdata && langdata.ChannelName ? langdata.ChannelName : 'Channel Name'} rules={[{ required: true, message: langdata && langdata.Pleaseselectthechannel ? langdata.Pleaseselectthechannel : 'Please select the channel' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={
										langdata && langdata.SelectChannel
											? langdata.SelectChannel
											: 'Select Channel'
									}
									optionFilterProp="children"
									value={channelId}
									options={channels}
									disabled={pidsId==null}
									onSelect={(e) => handleSelectChannel(e,'add')}
																											
																													
								/>  
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>

						<Col span={12}>
							<Form.Item label={langdata && langdata.Chain ? langdata.Chain : 'Chain'} rules={[{ required: true, message: langdata && langdata.PleaseSelectChain ? langdata.PleaseSelectChain : 'Please Select the  Chain' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={
										langdata && langdata.PleaseSelectChain ? langdata.PleaseSelectChain : 'Please Select the  Chain'
									}
									optionFilterProp="children"
									value={ChainId}
									options={multiplemodelfilter}
									disabled={channelId==null}
									onSelect={(e) => handleSelectModel(e,'add')}
																											
																													
								/>  
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.NewConfiguration ? langdata.NewConfiguration:'New Configuration'}</b></Typography>
						</Col>
						<Col span={12} justifyContent="end" style={{display:'flex', justifyContent:'flex-end'}}>
							<Button
								style={{margin:'5px'}} 
								type="primary" 
								icon={<PlusOutlined />}
								onClick={handleFilterConfig}
							/>
						</Col>
					</Row>

					{
						stateconfigs.map((item, stateindex)=>{
							return (
								<><Row gutter={24} key={stateindex}>
									<Col span={7}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : 'none', marginTop: '10px' }}>
												{stateindex === 0 ? langdata?.Name || 'Name' : ''}
											</Typography>}
										>
											<Input
												placeholder={langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name'}
												onChange={e => handleChangeConfigs(stateindex, 'name', e)}
												value={item.name}
											/>
											
										</Form.Item>

									</Col>
									<Col span={6}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0 ? langdata?.Value || 'Value' : ''}
											</Typography>}
										>
											<Input

												onChange={e => handleChangeConfigs(stateindex, 'value', e)}
												placeholder={langdata && langdata.Value ? langdata.Value : 'Value'}
												value={item.value} />
										</Form.Item>
									</Col>
									<Col span={6}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0
													? langdata?.DefaultValue || 'DefaultValue' : ''}
											</Typography>}
										>
											<Input

												onChange={e => handleChangeConfigs(stateindex, 'default', e)}
												value={item.default}
												placeholder={langdata && langdata.DefaultValue ? langdata.DefaultValue : 'Default Value'} />
										</Form.Item>
									</Col>
									<Col span={3}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0 ? langdata?.Override || 'Override' : ''}
											</Typography>}
										>
											<Switch

												size="small"
												checked={item.override}
												onChange={(e) => {
													handleChangeConfigs(stateindex, 'override', e);
												} } />
										</Form.Item>
									</Col>
									<Col span={2} style={{ marginTop: '35px', marginLeft: '', textAlign: 'center' }}>
										<Button
											danger
											icon={<DeleteOutlined />}
											onClick={() => handleDeleteConfig(stateindex)}
											disabled={stateconfigs.length === 0} />
									</Col>
								</Row>
								<Row gutter={24} key={stateindex}>
									<Col span={12}>
									
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0
													? langdata?.infoContent || 'Info Content' : ''}
											</Typography>}
										>
											<Input
												onChange={e => handleChangeConfigs(stateindex, 'infoContent', e)}
												value={item.infoContent}
												placeholder={langdata && langdata.infoContent ? langdata.infoContent : ''} />
										</Form.Item>		
									</Col>
									<Col span={12}>
									
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0
													? langdata?.OrderId || 'Order Id' : ''}
											</Typography>}
										>
											<Input
												type='number'
												onChange={e => handleChangeConfigs(stateindex, 'sort', e)}
												value={item.sort}
												placeholder={langdata && langdata.OrderId ? langdata.OrderId : 'Order Id'} />
										</Form.Item>		
									</Col>
									
								</Row></>	
							);
						})
					}
				</Form>
			</Modal>

			<Modal title={langdata && langdata.Confirmdelete ? langdata.Confirmdelete : 'Confirm delete'} open={showDeleteModal} onOk={handleOk} onCancel={handleCancel}
				footer={[
				// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CANCEL ? langdata.CANCEL : 'CANCEL'}</Button>
						<Button key="submit" type="primary" onClick={handleDelete}>{langdata && langdata.DELETE ? langdata.DELETE : 'DELETE'}</Button>
					</Space>
				]}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}>{ langdata && langdata.Areyousureyouwanttodeletethischainselectorconfig ? langdata.Areyousureyouwanttodeletethischainselectorconfig :'Are you sure you want to delete this Chain selector config?'}</Col>
				</Row>
			</Modal>

			<Spin fullscreen spinning={data.loading} />
		</Content>
	);
}